import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { environment } from 'src/environments/environment';
import { InvestmentService } from 'src/app/services/investment.service';
declare var $: any;
import * as _ from 'lodash';

@Component({
  selector: 'app-investmentlist',
  templateUrl: './investmentlist.component.html',
  styleUrls: ['./investmentlist.component.css']
})
export class InvestmentlistComponent implements OnInit {
  public environmentSettings: any;
  isSearchDivVisible = false;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfInvestment: DataTables.Settings = {};
  registerDirectorList: any[];
  masterDirectorList: any[];
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerInvestment: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  response: boolean;
  deleteInvestmentId: any;
  dateOfAcquisition: any;
  dateOfAcquisitionTo: any;
  nameOfPerson: any;
  ParticularId: any;

  constructor(private InvestmentService: InvestmentService, private router: Router,
     private alert: AlertComponent,private activatedRoute: ActivatedRoute) {
    this.response = false;
  }

  ngOnInit() {

    // this.getRegisterDirectorList();
    this.environmentSettings = environment;
    this.dtOptionsOfInvestment = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Investment',
          title: 'Investment',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 4],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
    // setTimeout(() => {
    //   $("#investmentlistTable").DataTable().columns.adjust().draw();
    // }, 200);
    this.getRegisterDirectorList();

  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['investment','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  // loadDetailsById(directorId) {
  //   this.router.navigate(['/intern/edit/', directorId]);
  // }

  adjustdirectormasterTable() {
    var directorData = this.masterDirectorList;
    if (directorData.length) {
      this.masterDirectorList = [];
      $("#investmentlistTable").DataTable().destroy();
      this.masterDirectorList = directorData;
      this.dtTriggerMasterDirector.next();
      setTimeout(() => {
        $("#investmentlistTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#investmentlistTable").DataTable().columns.adjust().draw();
    });
  }


  getRegisterDirectorList() {

    this.registerDirectorList = [];
    this.InvestmentService.getRegisterDirector({ "isSearch": false }).subscribe(registerList => {
      this.registerDirectorList = registerList.data;
      this.dtTriggerInvestment.next();
    });
  }
  loadInvestmentDataById(investmentId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['investment','edit',investmentId]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['/Investment/edit/', investmentId]);
  }

  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfAcquisition,
      toDate: this.dateOfAcquisitionTo,
      name: this.nameOfPerson
    }
    this.InvestmentService.generateInvestmentDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.InvestmentService.downloadInvestmentFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.InvestmentService.downloadInvestmentPdfFile(id, 'Multi');
  }

  // editInvestment(investmentId){
  //   this.router.navigate(['/Investment/edit/', investmentId]);
  //   console.log("id",investmentId);
  //   this.InvestmentService.getInvestmentData(investmentId).subscribe(editList => {
  //     console.log("hgfjh",editList);
  //   })
  // }
  confirmDelete(id) {
    this.deleteInvestmentId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deleteInvestment() {
    this.InvestmentService.removeinvestmentdetails(this.deleteInvestmentId)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#investmentlistTable").DataTable().destroy();
          $('#deleteConfirm').modal('toggle');
        } else {
          this.alert.error(response.message);
        }
        this.getRegisterDirectorList();
      });

  }
  editinvestmentdetail(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['investment','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['investment/edit/', _id]);
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch() {
    var searchParam =
    {
      "nameOfPerson": this.nameOfPerson,
      'dateOfAcquisition': this.setDate(this.dateOfAcquisition),
      'dateOfAcquisitionTo':this.setDate(this.dateOfAcquisitionTo),
      'isSearch': true,
    };

    this.registerDirectorList = [];
    $("#investmentlistTable").DataTable().destroy();
    this.InvestmentService.getRegisterDirector(searchParam).subscribe(registerList => {
      this.registerDirectorList = registerList.data;
      this.dtTriggerInvestment.next();
    });
  }
  clearAdvSearch() {
    this.dateOfAcquisition = undefined;
    this.dateOfAcquisitionTo = undefined;
    this.nameOfPerson = '';
    $("#investmentlistTable").DataTable().destroy();
    this.getRegisterDirectorList();

    // this.response = true;

    //   localStorage.setItem('searchInvestmentsflag', 'false');
  }

}

